export default __webpack_public_path__ + "static/media/img_01.6968c240.jpg";